import { createFileRoute } from '@tanstack/react-router';
import { ManagementDashboardPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/management')({
  component: ManagementRoute,
});

function ManagementRoute() {
  const { orgId } = Route.useParams();
  return <ManagementDashboardPage orgId={orgId} />;
}
